<template>
    <v-container>
        <v-breadcrumbs :items="breadcrumbs" large></v-breadcrumbs>

        <v-card class="mb-10">
            <v-card-text>
                <v-form @submit.prevent="formEdit" ref="refEditProduct" lazy-validation>
                    <v-row>
                        <v-col cols="12" class="text-center">
                            Imagen pricipal *
                            <div style="position: relative; width:250px" class="mb-6 mx-auto">
                                <v-img
                                    :src="previewImg"
                                    height="150"
                                    style="background-color: grey"
                                ></v-img>
                                <v-btn
                                    absolute
                                    dark
                                    fab
                                    bottom
                                    right
                                    @click="openInputFile"
                                >
                                    <v-icon>mdi-image</v-icon>
                                </v-btn>
                                <input type="file" @change="upBanner" class="d-none" ref="fileInput" accept="image/png, image/jpeg">
                            </div>
                            <span class="red--text" v-if="errors['banner']">{{ (errors['banner']) ? errors['banner'][0] : '' }}</span>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-text-field
                                label="Nombre *"
                                dense
                                outlined
                                :rules="[rules.required]"
                                v-model="data.name"
                                :error="(errors['name']) ? true : false"
                                :error-messages="(errors['name']) ? errors['name'][0] : ''"
                            ></v-text-field>
                            <label for="">Descripción (opcional)</label>
                            <vue-editor v-model="data.description" :editor-toolbar="customToolbar" class="mb-6" />
                            <v-text-field
                                label="Precio (opcional)"
                                dense
                                outlined
                                type="number"
                                v-model="data.price"
                                :error="(errors['price']) ? true : false"
                                :error-messages="(errors['price']) ? errors['price'][0] : ''"
                            ></v-text-field>
                            <!-- status -->
                            <v-switch
                                v-model="data.state"
                                inset
                                :label="`Estado: ${(data.state)?'activo':'inactivo'}`"
                            ></v-switch>
                            <!-- end status -->
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-select
                                :items="itemsCategories"
                                item-text="name"
                                item-value="id"
                                label="Categoría *"
                                dense
                                outlined
                                multiple
                                :rules="[rules.required]"
                                v-model="data.category"
                                :error="(errors['category_id']) ? true : false"
                                :error-messages="(errors['category_id']) ? errors['category_id'][0] : ''"
                            ></v-select>
                            <v-select
                                :items="itemsComplements"
                                item-text="title"
                                item-value="id"
                                label="Complementos"
                                outlined
                                v-model="data.complements"
                                multiple
                                chips
                            ></v-select>
                            <!-- gallery -->
                            <div class="mb-4">
                                Galería <small>Máximo {{ maxImages }} imágenes</small>
                                <input type="file"
                                    accept="image/png,image/jpeg,image/jpg"
                                    ref="fileGallery"
                                    class="d-none"
                                    @change="previewImage"
                                >
                                <v-row no-gutters>
                                    <v-col
                                        cols="12"
                                        class="pa-1 pa-sm-2"
                                    >
                                        <v-btn @click="addNewImage" color="primary" :disabled="data.gallery.length >= maxImages">
                                            Añadir imagen <v-icon>mdi-image-plus</v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="2"
                                        class="pa-1 pa-sm-2"
                                        v-for="(url, index) in previewGallery" :key="index"
                                    >
                                        <v-img
                                            :src="(url!='')?url:'/images/overlay-img.png'"
                                            :lazy-src="(url!='')?url:'/images/overlay-img.png'"
                                            aspect-ratio="1"
                                            color="grey lighten-2"
                                            class="text-right"
                                        >
                                            <v-btn v-if="url!=''" @click="removeImage(index)" fab x-small dark color="red darken-3">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-img>
                                    </v-col>
                                </v-row>
                            </div>
                            <!-- gallery END -->
                        </v-col>

                        <!-- información extra -->
                        <v-col cols="12">
                            <div class="text-h5">Información extra</div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-checkbox
                                v-model="data.extraBtn"
                                :value="true"
                                label="Añadir botón más información"
                            ></v-checkbox>
                            <v-radio-group
                                v-model="data.typeBtn"
                                column
                                v-if="data.extraBtn"
                            >
                                <v-radio
                                    label="Página URL externa"
                                    value="url"
                                ></v-radio>
                                <v-radio
                                    label="Página URL de video de Youtube"
                                    value="video"
                                ></v-radio>
                            </v-radio-group>
                            <v-text-field
                                v-if="data.extraBtn"
                                label="Texto del botón"
                                outlined
                                dense
                                v-model="data.textBtn"
                            ></v-text-field>
                            <v-text-field
                                v-if="data.typeBtn!=='' && data.extraBtn"
                                :label="data.typeBtn=='url'?'Página URL externa':'Código de video de Youtube'"
                                outlined
                                dense
                                v-model="data.urlBtn"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" class="text-center">
                            <v-btn type="submit" color="primary" :loading="loading">
                                Actualizar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script>
import draggable from 'vuedraggable'
export default {
    components: {
        draggable,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Productos/Servicios',
                    disabled: false,
                    href: '/admin/products',
                },
                {
                    text: 'Editar servicio',
                    disabled: true,
                    href: '',
                }
            ],
            dialogAdd: false,
            dialogEdit: false,
            tmpId: null,
            itemsCategories: [],
            itemsComplements: [],
            previewImg: '',
            data: {
                id: '',
                name: '',
                description: '',
                complements: [],
                category: [],
                banner: null,
                price: '',
                gallery: [],
                // extra
                extraBtn: false,
                typeBtn: '',
                textBtn: '',
                urlBtn: '',
            },
            // gallery
            previewGallery: [],
            maxImages: 15,
            // form validate
            rules: {
                required: value => !!value || 'Campo obligatorio.',
                size: value => !value || value.size < 7000000 || '¡El tamaño de la foto debe ser inferior a 2 MB!',
            },
            errors: {},
            // editor
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [{ align: "" }, { align: "center" }, { align: "right"}, { align: "justify"}],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ color: [] }]
            ],
        }
    },
    props: ['dataProd'],
    created() {
        this.getCategories();
        this.getComplements();

        const tmpProd = JSON.parse(this.dataProd)
        this.data.id = tmpProd.id
        this.data.name = tmpProd.name
        this.data.description = tmpProd.description
        this.data.category = tmpProd.tempCats
        this.data.price = tmpProd.price??''
        this.data.state = +tmpProd.state
        this.previewImg = tmpProd.banner

        // extra
        this.data.extraBtn = tmpProd.btn_extra?true:false
        this.data.typeBtn = tmpProd.type_btn_extra
        this.data.textBtn = tmpProd.text_btn_extra
        this.data.urlBtn = tmpProd.url_btn_extra

        if (tmpProd.gallery.length > 0) {
            tmpProd.gallery.forEach(element => {
                this.data.gallery.push(element.img)
                this.previewGallery.push(element.img)
            });
        }
        if (this.previewGallery.length < this.maxImages) {
            for (let j = 0; j < (this.maxImages - tmpProd.gallery.length); j++) {
                this.previewGallery.push('')
            }
        }
        if (tmpProd.complements.length > 0) {
            tmpProd.complements.forEach(compln => {
                this.data.complements.push(compln.id)
            });
        }
    },
    methods: {
        // gallery
        addNewImage() {
            this.$refs.fileGallery.click();
        },
        previewImage (event) {
            const file = event.target.files[0]
            const fileType = file.type
            if (fileType == 'image/jpeg' || fileType == 'image/jpg' || fileType == 'image/png') {
                this.data.gallery.push(file)
                this.previewGallery[this.data.gallery.length - 1] = URL.createObjectURL(file)
            } else {
                this.$notify.warning('Formato no permitido.');
                return
            }
        },
        removeImage(i) {
            this.previewGallery.splice(i, 1)
            this.previewGallery.push('')
            this.data.gallery.splice(i, 1)
        },
        // end Gallery
        async getCategories() {
            await axios.post('/admin/list-categories', {})
            .then(response => {
                this.itemsCategories = response.data;
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async getComplements() {
            await axios.post('/admin/list-complements')
            .then((response) => {
                // console.log(response)
                this.itemsComplements = response.data
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        // create product
        openInputFile() {
            this.$refs.fileInput.click();
        },
        upBanner(event) {
            const file = event.target.files[0];
            this.previewImg = URL.createObjectURL(file);
            this.data.banner = file;
        },
        // *************************** register ***************************//
        async formEdit() {
            if (this.$refs.refEditProduct.validate()) {
                // if (this.listProd.length > 0) {
                    this.loading = true
                    this.errors = {};
                    const formData = new FormData();
                    formData.append('name', this.data.name);
                    formData.append('description', this.data.description);
                    formData.append('banner', this.data.banner);
                    formData.append('categories', JSON.stringify(this.data.category));
                    formData.append('price', this.data.price);
                    formData.append('state', (this.data.state)?1:0)
                    formData.append('complements', JSON.stringify(this.data.complements));
                    // products
                    for (let i = 0; i < this.data.gallery.length; i++) {
                        formData.append(`gallery[${i}]`, this.data.gallery[i]);
                    }

                    formData.append('type', 'page')

                    // extra button
                    formData.append('btn_extra', this.data.extraBtn?1:0)
                    formData.append('text_btn_extra', this.data.textBtn)
                    formData.append('type_btn_extra', this.data.typeBtn)
                    formData.append('url_btn_extra', this.data.urlBtn)

                    formData.append('_method', 'PUT')

                    await axios.post(`/admin/edit-service/${this.data.id}`, formData)
                    .then(response => {
                        // console.log(response);
                        if (response.data === 'ok') {
                            this.$alert('', 'Servicio actualizado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                            // this.previewImg = ''
                            this.$refs.refEditProduct.resetValidation()
                        }

                        this.loading = false
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            this.errors = error.response.data.errors
                        }
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                        this.loading = false
                    })
                // } else {
                //     this.$notify.info("Debe registrar al menos un producto.");
                // }
            }
        }
    },
}
</script>
<style lang="scss">
.list-group-item {
    border-bottom: 1px solid #e0e0e0;
}
</style>
